import BaseButton from '@/components/base/buttons/BaseButton'
import BaseIcon from '@/components/base/icons/BaseIcon'
import BaseSelect from '@/components/base/forms/BaseSelect'
import BaseCard from '@/components/base/ui/BaseCard'
import BaseInput from '@/components/base/forms/BaseInput'
import BaseSpinInput from '@/components/base/forms/BaseSpinInput'
import BaseCheckbox from '@/components/base/forms/BaseCheckbox'
import BaseRadioGroup from '@/components/base/forms/BaseRadioGroup'
import BaseTextarea from '@/components/base/forms/BaseTextarea'
import IconButton from '@/components/base/buttons/IconButton'
import { BCol, BRow, BContainer } from 'bootstrap-vue'

export default {
  install (Vue) {
    Vue.component('base-button', BaseButton)
    Vue.component('base-icon', BaseIcon)
    Vue.component('base-select', BaseSelect)
    Vue.component('base-card', BaseCard)
    Vue.component('base-input', BaseInput)
    Vue.component('base-spin-input', BaseSpinInput)
    Vue.component('base-checkbox', BaseCheckbox)
    Vue.component('base-radio-group', BaseRadioGroup)
    Vue.component('base-textarea', BaseTextarea)
    Vue.component('b-row', BRow)
    Vue.component('b-col', BCol)
    Vue.component('b-container', BContainer)
    Vue.component('icon-button', IconButton)
  }
}



// WEBPACK FOOTER //
// ./src/plugins/registerGlobalComponents.js